import {TrackAddToCartDTO} from "@app/core/tracking/domain/dtos/track-add-to-cart.dto";
import {TrackAddShippingInfoDto} from "@app/core/tracking/domain/dtos/track-add-shipping-info.dto";
import {TackBeginCheckoutDto} from "@app/core/tracking/domain/dtos/tack-begin-checkout.dto";
import {TrackViewItemDto} from "@app/core/tracking/domain/dtos/track-view-item.dto";
import {TrackViewPromotionDto} from "@app/core/tracking/domain/dtos/track-view-promotion.dto";
import {TrackViewItemListDto} from "@app/core/tracking/domain/dtos/track-view-item-list.dto";
import {TrackPurchaseDto} from "@app/core/tracking/domain/dtos/track-purchase.dto";
import {TrackSelectPromotionDto} from "@app/core/tracking/domain/dtos/track-select-promotion.dto";
import {TrackAddPaymentInfoDto} from "@app/core/tracking/domain/dtos/track-add-payment-info.dto";
import {TrackAddToWishlistDto} from "@app/core/tracking/domain/dtos/track-add-to-wishlist.dto";
import {TrackRemoveFromCartDto} from "@app/core/tracking/domain/dtos/track-remove-from-cart.dto";
import {TrackSelectItemDto} from "@app/core/tracking/domain/dtos/track-select-item.dto";

export abstract class TrackingService {

    abstract addToCart(dto: TrackAddToCartDTO): void;

    abstract addShippingInfo(dto: TrackAddShippingInfoDto): void;

    abstract beginCheckout(dto: TackBeginCheckoutDto): void;

    abstract viewItem(dto: TrackViewItemDto): void;

    abstract viewPromotion(dto: TrackViewPromotionDto): void;

    abstract viewItemList(dto: TrackViewItemListDto): void;

    abstract purchase(dto: TrackPurchaseDto): void;

    abstract selectPromotion(dto: TrackSelectPromotionDto): void;
    
    abstract addPaymentInfo(dto: TrackAddPaymentInfoDto): void;

    abstract signUp(): void;

    abstract addToWishlist(dto: TrackAddToWishlistDto): void;

    abstract removeFromCart(dto: TrackRemoveFromCartDto): void;

    abstract selectItem(dto: TrackSelectItemDto): void;
}
